import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-uslovi-koriscenja',
  standalone: true,
  templateUrl: './uslovi-koriscenja.component.html',
  styleUrl: './uslovi-koriscenja.component.scss',
  imports: [CommonModule, RouterModule]
})
export class UsloviKoriscenjaComponent {
  readonly lastUpdated = '01.07.2026.';

  goBack(): void {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }
}
